<div class="ap-container">
    <div class="ap-intro__content">
        <div class="ap-intro__logo"></div>
        <div class="ap-intro__name ap-text-big-title">Ale Alexander</div>
        <div class="ap-intro__subtitle ap-text-body-subtitle">Art Director | Graphic Designer</div>
        <div class="ap-line-break">
            <i class="far fa-hand-peace"></i>
        </div>
    </div>
</div>